import React, { Component } from 'react'
import styled, { css, injectGlobal } from 'styled-components';
import { rgba } from 'polished';
import Modal from 'react-modal';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock'

import { Carousel } from '../'

import { media } from '../../styles/utils';
import { green, greenSecondary } from '../../styles/colors';
import { hoverState, padding, bgImage, bgIcon } from '../../styles/global';

import arrowLeft from '../../assets/icons/slider-arrow-left.svg'
import arrowRight from '../../assets/icons/slider-arrow-right.svg'
import close from '../../assets/icons/close.svg'

class CarouselModal extends Component {

    constructor(props) {
		super(props);
		this.slider = React.createRef();
	}

    state = {
        activeSlide: this.props.activeSlide
    }

    componentDidMount = () => {
    }

    componentDidUpdate = (prevProps, prevState) => {
        const { active } = this.props;

        console.log(prevProps.active, active)

        if (active !== prevProps.active) {   
            document.body.style.overflow = active ? 'hidden' : 'auto';  
        }

        if (prevProps.activeSlide !== this.props.activeSlide) {
            const index = this.props.activeSlide;
            this.slider.current.slider.current.slickGoTo(index == 1 ? 0 : index - 1, true)

            this.setState({
                activeSlide: index
            })
        }
    }
    
    onSlideChange = (index) => {
        const { updateActiveSlide } = this.props;
        updateActiveSlide(index == 1 ? 0 : index - 1)
    }

    onArrowClick = (type) => {
        if (type == 'right') {
            this.slider.current.slider.current.slickNext()
        }

        if (type == 'left') {
            this.slider.current.slider.current.slickPrev()
        }
	}
        
    render() {
        const { slides, active, toggle, activeSlide } = this.props;

        const customStyles = {
            content: {
                top: '50%',
                left: '50%',
                right: 'auto',
                bottom: 'auto',
                marginRight: '-50%',
                transform: 'translate(-50%, -50%)',
                padding: 0,
                border: 0,
                backgroundColor: 'transparent',
                transition: 'opacity 0.5s ease',
                height: '100%',
                maxHeight: '100vh',
                overflow: 'hidden',
                display: 'flex',
            },
            overlay: {
                background: 'transparent',  
                zIndex: 11,
                pointerEvents: active ? 'all' : 'none',
                top: '-1px',
            }
		};
        
		return (
			<Modal
				isOpen={true}
				style={customStyles}
			>

                <Wrapper
                    active={active}
                >
                    <Container
                        className={'carousel-modal'}
                    >
                        <Carousel
                            slides={slides}
                            ref={this.slider}
                            styles={carouselStyles}
                            afterChange={active && this.onSlideChange}
                            settings={{
                                initialSlide: this.state.activeSlide == 1 ? 0 : this.state.activeSlide - 1,
                                slidesToShow: 1,
                                slidesToScroll: 1,
                                infinite: true,
                                speed: 300,
                                arrows: false,
                            }}
                        />

                        <Arrow
                            type={'right'}
                            onClick={() => this.onArrowClick('right')}
                        />

                        <Arrow
                            type={'left'}
                            onClick={() => this.onArrowClick('left')}
                        />

                        <Close
                            onClick={toggle}
                        />
                    </Container>
                </Wrapper>

			</Modal>
		)
    }
}

const Wrapper = styled.div`
    transition: opacity 0.25s ease;
    opacity: 0;
    background: white;
    height: 100%;
    pointer-events: none;

    ${props => {
        if (props.active) return css`
            pointer-events: all;
            opacity: 1;
        `
    }}
`

const ClickDetector = styled.div`
    cursor: zoom-in;
    
    > * {
        pointer-events: none
    }
`

const carouselStyles = css`
    width: 100vw;
    height: 100vh;
`

const Container = styled.div`
    ${carouselStyles};
    display: flex;
    flex-direction: column;
    justify-content: center;
`

const Close = styled.div`
    position: absolute;
    top: 50px;
    right: 50px;
    width: 18px;
    height: 18px;
    ${bgIcon}
    background-image: url(${close});
    ${hoverState}
    cursor: pointer;

    ${media.laptop`
        top: 36px;
        right: 36px;
    `}

    ${media.phone`
        top: 42px;
        right: 42px;
    `}
`

const Arrow = styled.div`
    position: absolute;
    top: 50%;
    
    width: 18px;
    height: 18px;
    ${bgIcon}
    ${hoverState}
    cursor: pointer;

    ${media.phone`
        display: none;
    `}

    ${props => {
		if (props.type == 'left') return css`
            left: 55px;
            background-image: url(${arrowLeft});

            ${media.laptop`
                left: 40px;
            `}
        `

        if (props.type == 'right') return css`
            right: 55px;
            background-image: url(${arrowRight});

            ${media.laptop`
                right: 40px;
            `}
        `
    }}
`

injectGlobal`
    .carousel-modal {
        .slick-list {
            overflow: visible !important;
        }

        .slick-slide {
            cursor: auto !important;
        }
    }
`

export default CarouselModal;


// WEBPACK FOOTER //
// ./src/components/CarouselModal/CarouselModal.js